import * as auth from './../actions/auth.actions'

export interface State {
  loggedIn: boolean
  token: string | null,
  refreshToken: string
}

const initialState: State = {
  loggedIn: false,
  token: null,
  refreshToken: null
}

export function reducer(state = initialState, action: auth.Actions): State {
  switch(action.type) {
    case auth.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        token: action.payload.token,
        refreshToken: action.payload.tokenRefresh
      }

    case auth.SET_TOKEN:
      return {
        ...state,
        token: action.payload
      }

    case auth.LOGOUT: {
      return initialState;
    }
    
    default: {
      return state;
    }
  }
}

export const getLoggedIn = (state: State) => state.loggedIn
export const getToken = (state: State) => state.token
export const getRefreshToken = (state: State) => state.refreshToken
